import { MARKETS } from "../data/site";
import { useReveal } from "../hooks/useReveal";

export default function MarketsStrip() {
    const ref = useReveal();
    return (
        <section
            id="markets"
            data-testid="markets-section"
            className="bg-white py-16"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <div ref={ref} className="reveal flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end">
                    <div className="max-w-xl">
                        <span className="text-xs uppercase tracking-[0.22em] text-brand-red">
                            We Serve Global Importers
                        </span>
                        <h2 className="mt-3 font-display text-3xl font-bold tracking-[-0.025em] sm:text-4xl">
                            Trusted by buyers in 30+ countries.
                        </h2>
                    </div>
                    <div className="flex flex-wrap gap-2">
                        {MARKETS.map((c) => (
                            <span
                                key={c}
                                data-testid={`market-${c.toLowerCase().replace(/\s+/g, "-")}`}
                                className="rounded-full border border-hairline bg-neutral-bg px-4 py-1.5 text-sm font-medium text-ink"
                            >
                                {c}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
